import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledActionBar } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/action-bar/action-bar.scss";
import Button from "segments/desktop/core-components/button/button";
import { SECONDARY_BUTTON_TYPE, SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import MenuDivider from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/menu-divider/menu-divider";
import { CONTACT_US_FROM_HEADER_PAGE_LINK } from "constants/links";
const ActionBar = ({ translate })=>{
    return /*#__PURE__*/ _jsxs(StyledActionBar, {
        className: "action-bar",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "cta-wrapper",
                children: /*#__PURE__*/ _jsx(Button, {
                    buttonType: SIGNUP_BUTTON_TYPE
                })
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "contact-sales-wrapper",
                children: /*#__PURE__*/ _jsx(Button, {
                    buttonType: SECONDARY_BUTTON_TYPE,
                    buttonText: translate("header.contactSales"),
                    url: CONTACT_US_FROM_HEADER_PAGE_LINK,
                    extraEventData: {
                        englishText: "Contact sales"
                    }
                })
            })
        ]
    });
};
export default ActionBar;
